import React, { useEffect, useState } from "react";
import { Col, Row, Button, Card, ProgressBar } from "react-bootstrap";
import { useContext } from "react";
import SimpleContext from "./../../context/SimpleContext";
import "./Factors.css";
import config from "./../../../services/config.json";
import axios from "axios";
import { saveAs } from "file-saver";
import right from "../../img/right.png";
import { useHistory } from "react-router";
import Preloader from "../../Preloader/preloader";
import Preloader2 from "../../Preloader/preloader3";
import { browserName, browserVersion } from "react-device-detect";
const Savabegh = () => {
  const context = useContext(SimpleContext);
  const history = useHistory();

  useEffect(() => {
    // context.KfPorder();
    // context.CustomerOrder();
    context.Orderss();
  }, []);

  const [factor, setfactor] = useState([]);
  const goKFP = () => {
    context.setShowKfp(true);
    context.setShowApi(false);
  };
  const goApi = () => {
    context.setShowKfp(false);
    context.setShowApi(true);
  };
  return (
    <>
      {context.preButton === true ? (
        <Preloader />
      ) : (
        <>
          <div
            style={{
              width: "100%",
              display: "flex",
              height: "8vh",
              position: "fixed",
              zIndex: "3",
              top: "0",
              backgroundColor: "#fff",
              boxShadow: "5px 5px 10px #e0e0e6",
            }}
          >
            <div
              style={{
                width: "15%",
                display: "flex",
                justifyContent: "flex-start",
                textAlign: "center",
                alignItems: "center",
              }}
            >
              <img
                onClick={() => history.go(-1)}
                className="backIcon"
                src={right}
              />
            </div>
            <div
              style={{
                width: "70%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <p
                style={{
                  margin: "0",
                  fontWeight: "bold",
                  fontSize: "13px",
                  display: "flex",
                  textAlign: "center",
                  alignItems: "center",
                  padding: "5px",
                }}
              >
                سوابق سفارشات
              </p>
            </div>
            <div style={{ width: "15%", visibility: "hidden" }}>
              <p></p>
            </div>
          </div>
          <div style={{ marginTop: "8vh" }} className="productsmain">
            {/* <div
              style={{ position: "fixed", top: "8vh" }}
              className="sefareshatNan"
            >
              <Row className="rows">
                <Col onClick={() => goApi()}>
                  <Row className="minirows">
                    <div
                      style={{
                        backgroundColor: "#fff",
                        borderRadius: "50%",
                        maxWidth: "60px",
                      }}
                    >
                      <img
                        src="images/Api.png"
                        alt=""
                        className="miniSafareshatImag"
                      />
                    </div>
                  </Row>
                  <Row
                    className={
                      context.showapi === true ? "minirowwithline" : "minirows"
                    }
                  >
                    <p style={{ margin: "0", fontSize: "15px" }}>سفارشات اپی</p>
                  </Row>
                </Col>
                <Col onClick={() => goKFP()}>
                  <Row className="minirows">
                    <div
                      style={{
                        backgroundColor: "#fff",
                        borderRadius: "50%",
                        maxWidth: "60px",
                      }}
                    >
                      <img
                        src="images/cart_failed.png"
                        alt=""
                        className="miniSafareshatImag"
                      />
                    </div>
                  </Row>
                  <Row
                    className={
                      context.showKfp === true ? "minirowwithline" : "minirows"
                    }
                  >
                    <p style={{ margin: "0" }}>سفارشات کیمیافرد</p>
                  </Row>
                </Col>
              </Row>
            </div> */}

            <div className="factorMainPlace">
              {context.api.length > 0 ? (
                context.api.map((factor, i) => (
                  <TaeedShodeHa key={i} factor={factor} i={i} />
                ))
              ) : (
                <h6 style={{ color: "grey", marginTop: "70%" }}>
                  سفارشی نداشته اید!
                </h6>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Savabegh;

export function TaeedShodeHa({ factor, i }) {
  const context = useContext(SimpleContext);
  const [pre, setpre] = useState(false);

  const history = useHistory();
  //با استفاده از این تابع  کاربر را به صفحه جزییات سفارش هدایت میکنیم و وب سرویس ان را فراخانی میکنیم
  const goDetails = (id, title) => {
    context.details(id);
    context.setButtontitle(title);
    history.push("/detailsApi");
  };

  // function ShowFactor() {
  //   setpre(true);
  //   let MyTime = Date.now();
  //   let TimeHeader = context.Encriptor(MyTime + context.timeMiliSecondDef);
  //   const myheaders = {
  //     "atu-token": TimeHeader,
  //   };
  //   async function getData() {
  //     const url = `${context.baseUrlApiPakhsh}${config.downloadFactorWebApp}`;
  //     const formData = new FormData();
  //     formData.append(
  //       "factorID",
  //       Object.values(factor).length > 0 && factor.id,
  //     );
  //     formData.append("type", "api");
  //     formData.append(
  //       "customerId",
  //       Object.values(context.UseInFo).length > 0 && context.UseInFo.customerId,
  //     );
  //     formData.append("appTypeId", context.AppType);
  //     formData.append("appVersion", browserName);
  //     formData.append("AndroidVersion", browserVersion);
  //     formData.append("deviceId", context.UniqueUUID);
  //     const param = {
  //       method: "post",
  //       body: formData,
  //       headers: myheaders,
  //     };
  //     const sendRequest = await fetch(url, param);
  //     const response = await sendRequest.json();
  //     return response;
  //   }
  //   try {
  //     getData().then((data) => {
  //       setpre(false);
  //       if (data.popUp !== null) {
  //         if (data.popUp.text === "" && data.popUp.imageLink === "") {
  //           window.open(data.popUp.link, "noopener,noreferrer");
  //         } else {
  //           context.setmodalPopUp(true);
  //           context.setTextPopUp(data.popUp);
  //         }
  //       } else {
  //         context.setmodalPopUp(false);
  //       }
  //       if (data.code === 200) {
  //         context.Handelerror("فاکتور شما با موفقیت دانلود شد");
  //         saveAs(data.response.url);
  //       } else {
  //         context.Handelerror(data.message);
  //       }
  //     });
  //   } catch (ex) {
  //     console.log(ex);
  //   }
  // }
  const ShowFactor = async () => {
    setpre(true);

    try {
      const MyTime = Date.now();
      const TimeHeader = context.Encriptor(MyTime + context.timeMiliSecondDef);

      const formData = new FormData();

      formData.append(
        "factorID",
        Object.values(factor).length > 0 ? factor.id : "",
      );
      formData.append(
        "customerId",
        Object.values(context.UseInFo).length > 0
          ? context.UseInFo.customerId
          : "",
      );
      formData.append("appTypeId", context.AppType);
      formData.append("appVersion", browserName);
      formData.append("AndroidVersion", browserVersion);
      formData.append("deviceId", context.UniqueUUID);

      const response = await axios.post(
        `${context.baseUrlApiPakhsh}${config.downloadFactorWebApp}`,
        formData,
        {
          responseType: "blob",
          headers: {
            "atu-token": TimeHeader,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      const file = new Blob([response.data], {
        type: "application/pdf",
      });

      const fileURL = URL.createObjectURL(file);

      const link = document.createElement("a");
      link.href = fileURL;
      link.download = `factor-${factor.id}.pdf`;
      link.click();

      URL.revokeObjectURL(fileURL);

      context.Handelerror("فاکتور شما با موفقیت دانلود شد");
    } catch (err) {
      console.error(err);
      context.Handelerror("خطا در دانلود فاکتور");
    } finally {
      setpre(false);
    }
  };
  return (
    <>
      {Object.values(factor).length > 0 && (
        <div style={{ borderRadius: "20px" }} className="factors">
          <div className="factorPlaceHeader">
            <div className="factorheaderCols">
              <p style={{ margin: "0", fontSize: "13px" }}>
                شماره سفارش : {"  "}
                {factor.orderNumber}
              </p>
            </div>
            <img src={factor.orderType} />
            <div
              style={{ display: "flex", justifyContent: "flex-end" }}
              className="factorheaderCols"
            >
              <p style={{ margin: "0", fontSize: "13px" }}>
                {factor.orderDate}
              </p>
            </div>
          </div>
          <div
            onClick={() => goDetails(factor.id, factor.buttonTitle)}
            className="factorRowsHoldet"
          >
            <div className="factorRows">
              <div className="factorCols">
                مبلغ فاکتور: {"  "}
                {factor.amount}
              </div>
              {/* <div className="factorCols">
            مبلغ تخفیف: {"  "}
            {factor.discount}
            {"  "}ریال
          </div> */}
            </div>
            <div className="factorRows">
              {/* <div className="factorCols">
            مبلغ خالص: {"  "}
            {factor.amountNut}
            {"  "}ریال
          </div> */}
              <div className="factorCols">
                هزینه ارسال: {"  "}
                {factor.deliveryCost}
              </div>
            </div>
            {/* <div style={{ borderBottom: "none" }} className="factorRows"> */}
            {/* <div className="factorCols">
            تعداد ردیف فاکتور: {"  "}
            {factor.numberOfRows}
            {"  "}ردیف
          </div> */}
            {/* </div> */}
            <div style={{ borderBottom: "none" }} className="factorRows">
              <div className="factorCols">
                وضعیت سفارش : {factor.statusTitle}
              </div>
            </div>
            <div className="ProgressBarRow">
              <ProgressBar
                variant="success"
                now={factor.statusId}
                max={6}
                className="ProgressBar"
              />
            </div>
          </div>
          {factor.registerInVn !== false && (
            <div className="factorFooter">
              {pre === true ? (
                <button className="factorPlacefooter">
                  <Preloader2 />
                </button>
              ) : (
                <button
                  className="factorPlacefooter"
                  onClick={() => ShowFactor()}
                >
                  {factor.buttonTitle}
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
}

export function TaeedKfP({ factor, i }) {
  const history = useHistory();
  //با استفاده از این تابع  کاربر را به صفحه جزییات سفارش هدایت میکنیم و وب سرویس ان را فراخانی میکنیم
  const goDetailsKfp = (id) => {
    context.goOrders(id);
    history.push("/detailsKfp");
  };
  const context = useContext(SimpleContext);
  const [pre, setpre] = useState(false);
  const handleShowFactor = () => {
    setpre(true);
    let MyTime = Date.now();
    let TimeHeader = context.Encriptor(MyTime + context.timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    async function getData() {
      const url = `${context.baseUrlApiPakhsh}${config.downloadFactorWebApp}`;
      const formData = new FormData();
      formData.append(
        "factorID",
        Object.values(factor).length > 0 && factor.id,
      );
      formData.append("type", "kfp");
      formData.append(
        "customerId",
        Object.values(context.UseInFo).length > 0 && context.UseInFo.customerId,
      );
      formData.append("appTypeId", context.AppType);
      formData.append("appVersion", browserName);
      formData.append("AndroidVersion", browserVersion);
      formData.append("deviceId", context.UniqueUUID);
      const param = {
        method: "post",
        body: formData,
        headers: myheaders,
      };
      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }
    try {
      getData().then((data) => {
        setpre(false);
        if (data.popUp !== null) {
          if (data.popUp.text === "" && data.popUp.imageLink === "") {
            window.open(data.popUp.link, "noopener,noreferrer");
          } else {
            context.setmodalPopUp(true);
            context.setTextPopUp(data.popUp);
          }
        } else {
          context.setmodalPopUp(false);
        }
        if (data.code === 200) {
          context.Handelerror("فاکتور شما با موفقیت دانلود شد");
          saveAs(data.response.url);
        } else {
          context.Handelerror(data.message);
        }
      });
    } catch (ex) {
      console.log(ex);
    }
  };
  return (
    <>
      {Object.values(factor).length > 0 && (
        <div
          onClick={() => goDetailsKfp(factor.id)}
          style={{ borderRadius: "20px" }}
          className="factors"
        >
          <div className="factorPlaceHeader">
            <div className="factorheaderCols">
              <p style={{ margin: "0", fontSize: "13px" }}>
                شماره سفارش : {"  "}
                {factor.orderNumber}
              </p>
            </div>
            <div
              style={{ display: "flex", justifyContent: "flex-end" }}
              className="factorheaderCols"
            >
              <p style={{ margin: "0", fontSize: "13px" }}>
                {factor.orderDate}
              </p>
            </div>
          </div>
          <div
            onClick={() => goDetailsKfp(factor.id, factor.buttonTitle)}
            className="factorRowsHoldet"
          >
            <div className="factorRows">
              <div className="factorCols">
                مبلغ فاکتور: {"  "}
                {factor.amount}
              </div>
              {/* <div className="factorCols">
            مبلغ تخفیف: {"  "}
            {factor.discount}
            {"  "}ریال
          </div> */}
            </div>
            <div className="factorRows">
              {/* <div className="factorCols">
            مبلغ خالص: {"  "}
            {factor.amountNut}
            {"  "}ریال
          </div> */}
              <div className="factorCols">
                هزینه ارسال: {"  "}
                {factor.deliveryCost}
              </div>
            </div>
            {/* <div style={{ borderBottom: "none" }} className="factorRows">
          <div className="factorCols">
            تعداد ردیف فاکتور: {"  "}
            {factor.numberOfRows}
            {"  "}ردیف
          </div>
        </div> */}
            <div style={{ borderBottom: "none" }} className="factorRows">
              <div className="factorCols">
                وضعیت سفارش : {factor.statusTitle}
              </div>
            </div>
            {/* <div style={{ borderBottom: "none" }} className="factorRows"> */}
            <div className="ProgressBarRow">
              <ProgressBar
                variant="success"
                now={factor.statusId}
                max={6}
                className="ProgressBar"
              />
            </div>
          </div>
          {/* </div> */}
          {factor.registerInVn !== false && (
            <div className="factorFooter">
              {pre === true ? (
                <button className="factorPlacefooter">
                  <Preloader2 />
                </button>
              ) : (
                <button
                  className="factorPlacefooter"
                  onClick={() => handleShowFactor()}
                >
                  دانلود فاکتور
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
}
